import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { getRandomColorWithOpacity, filterZeroValuesForChart } from '@piqet-angular/data';
import { commonEnum, reportTitals } from '@piqet-angular/shared';
// import Chart from 'chart.js/auto';
import * as Highcharts from 'highcharts';
@Component({
  selector: 'piqet-angular-report-detail-contribution-chart',
  templateUrl: './report-detail-contribution-chart.component.html',
  styleUrls: ['./report-detail-contribution-chart.component.scss'],
})
export class ReportDetailContributionChartComponent implements OnChanges {
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions!: Highcharts.Options;
  allIndicators: string[] = [];
  chartOpacity: number = 0.5;
  @Input() impactItems: any;
  @Input() index: any;
  chartId: any;
  reportResource = reportTitals;
  componentItemsArray: any;
  @Input() isIsoReport = false;
  @Input() scenarioName = '';

  ngOnChanges(changes: SimpleChanges) {
    this.impactItems = changes['impactItems']?.currentValue;
    this.chartId = 'detailedContributionBarChartContainer' + this.impactItems.scenarioId;
    this.componentItemsArray = this.impactItems.componentItems;
    this.componentItemsArray = filterZeroValuesForChart(this.componentItemsArray, 'impactValues');
    this.chartOpacity = this.impactItems?.opacity || commonEnum.opacity;
    this.prepareChartData();
    this.promiseFun();
  }

  prepareChartData(): void {
    // Extract all indicators
    const categories = this.componentItemsArray[0].indicators;
    this.allIndicators = categories
      ? categories.split(';')
      : this.componentItemsArray.length > 0 && this.componentItemsArray[0].data
      ? ['Value 1', 'Value 2']
      : [];
    const allValues: number[] = [];

    if (this.componentItemsArray[0].impactValues) {
      // Use the original data format
      this.componentItemsArray.forEach((item: any) => {
        const values = item.impactValues.split(';').map((val: string) => parseFloat(val));
        allValues.push(...values);
      });
    }
  }

  async promiseFun() {
    await this.generateChart();
  }
  generateChart(): void {
    if (!this.componentItemsArray || this.componentItemsArray.length === 0) return;
    this.chartOptions = {};

    const indicatorsToShow = this.allIndicators;

    const indicatorIndices: number[] = [];
    indicatorsToShow.forEach((indicator, i) => {
      const index = this.allIndicators.findIndex((item, j) => item === indicator && j === i);
      if (index !== -1) {
        indicatorIndices.push(index);
      }
    });

    // Prepare series data
    const seriesData: any[] = [];

    const allColors = getRandomColorWithOpacity(this.chartOpacity);
    let usedColorIndex = 0;
    const categoryColors: any = {};
    const legendColors: { [key: string]: string } = {};

    this.componentItemsArray.forEach((item: any) => {
      if (item.name !== 'Total') {
        if (!categoryColors[item.name]) {
          categoryColors[item.name] = allColors[usedColorIndex % allColors.length];
          legendColors[item.name] = allColors[usedColorIndex % allColors.length].rgb;
          usedColorIndex++;
        }

        let filteredValues: any = [];
        let percentageValues: string[] = [];
        if (item.impactValues) {
          const allValues = item.impactValues.split(';').map((value: string) => parseFloat(value));
          filteredValues = indicatorIndices.map(index => allValues[index]);
        }

        if (item.percentage) {
          percentageValues = item.percentage.split(';');
        }
        seriesData.push({
          name: item.name,
          data: filteredValues,
          type: 'column',
          stack: 'stack1',
          color: item.color || categoryColors[item.name].rgba,
          borderColor: item.borderColor || categoryColors[item.name].rgb,
          className: 'top-border-bars',
        });
      }
    });

    this.chartOptions = {
      chart: {
        type: 'column',
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: indicatorsToShow,
        labels: {
          style: {
            fontSize: '14px',
            fontFamily: 'Neue Montreal, sans-serif',
          },
          padding: 10,
        },
        gridLineWidth: 1,
        gridLineDashStyle: 'Solid',
      },
      yAxis: {
        max: 100,
        tickInterval: 10,
        title: { text: 'Impact Percentage' },
        labels: {
          formatter: function () {
            return this.value + '%';
          },
        },
      },
      legend: {
        enabled: true,
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
        useHTML: true,
        labelFormatter: function () {
          const color = legendColors[this.name] || this.color;
          return `<span style="display: flex; align-items: center;">
              <span style="background-color: ${color}; width: 12px; height: 12px; border-radius: 50%; display: inline-block; margin-right: 8px;"></span>
              <span style="font-size: 14px; font-weight: bold; font-family: 'Neue Montreal', sans-serif;">${this.name}</span>
            </span>`;
        },
        symbolHeight: 0,
        symbolWidth: 0,
        symbolRadius: 0,
        itemMarginTop: 5,
        itemMarginBottom: 5,
        itemDistance: 20,
      },
      tooltip: {
        shared: true,
        useHTML: true,
        formatter: function (this: any): string {
          let s = `<b>${this.category}</b><br/>`;
          this.points.forEach((point: any) => {
            const color = legendColors[point.series.name] || point.color;
            const value = point.y?.toFixed(2) ?? '0.00';
            const percentage = point.percentage?.toFixed(2) ?? '0.00';

            s +=
              `<span style="color:${color}">\u25CF</span> ${point.series.name}: ` +
              `<b>${value}</b> (${percentage}%)<br/>`;
          });
          return s;
        },
      },
      plotOptions: {
        column: {
          // @ts-ignore
          stacking: 'percent',
          borderRadius: 0,
          dataLabels: {
            enabled: false,
          },
        },
        series: {
          states: {
            inactive: {
              enabled: false,
            },
          },
          pointPlacement: 0,
        },
      },
      series: seriesData,
      credits: {
        enabled: false,
      },
      navigation: {
        buttonOptions: {
          enabled: false,
        },
      },
    };
  }
}
